import { TimezoneType } from '@wix/bookings-uou-types';
export var DEFAULT_TIMEZONE = 'America/New_York';
export var BusinessPropertyName;
(function (BusinessPropertyName) {
    BusinessPropertyName["DEFAULT_TIMEZONE_PROPERTY_NAME"] = "defaultTimezone";
    BusinessPropertyName["CLIENT_CAN_CHANGE_TIMEZONE"] = "clientCanChangeTimezone";
})(BusinessPropertyName || (BusinessPropertyName = {}));
export function mapResponseToBusinessInfo(businessResponse) {
    var businessInfo = businessResponse.info;
    var businessProperties = businessResponse.businessProperties;
    if (businessInfo && businessProperties) {
        var defaultTimezoneType = getDefaultTimezoneType(businessProperties);
        var clientCanChangeTimezone = getClientCanChangeTimezoneIndication(businessProperties);
        var dateRegionalSettingsLocale = formatDateRegionalSettingsLocale(businessInfo.language, businessInfo.countryCode) || 'en-US';
        return {
            name: businessInfo.name,
            language: businessInfo.language,
            currency: businessInfo.currency,
            regionalSettingsLocale: businessInfo.locale,
            dateRegionalSettingsLocale: dateRegionalSettingsLocale,
            timeZone: businessInfo.timeZone || DEFAULT_TIMEZONE,
            timezoneProperties: {
                clientCanChooseTimezone: clientCanChangeTimezone === 'true',
                defaultTimezone: defaultTimezoneType,
            },
            countryCode: businessInfo.countryCode,
        };
    }
    return null;
}
function formatDateRegionalSettingsLocale(language, countryCode) {
    var locale = language === null || language === void 0 ? void 0 : language.split('-')[0];
    return "".concat(locale).concat(countryCode ? "-".concat(countryCode) : "");
}
export function getDefaultTimezoneType(businessProperties) {
    return (getPropertyValue(businessProperties === null || businessProperties === void 0 ? void 0 : businessProperties.customProperties, BusinessPropertyName.DEFAULT_TIMEZONE_PROPERTY_NAME) || TimezoneType.BUSINESS);
}
export function getClientCanChangeTimezoneIndication(businessProperties) {
    return (getPropertyValue(businessProperties === null || businessProperties === void 0 ? void 0 : businessProperties.customProperties, BusinessPropertyName.CLIENT_CAN_CHANGE_TIMEZONE) || 'true');
}
export function getPropertyValue(properties, propertyName) {
    var property = properties === null || properties === void 0 ? void 0 : properties.find(function (businessProperty) { return businessProperty.propertyName === propertyName; });
    return property === null || property === void 0 ? void 0 : property.value;
}
//# sourceMappingURL=business-info.mapper.js.map